import React, { useState } from "react";
import Header from "./Header";
import ActiveCoin from "./ActiveCoin";
import UpcomingCoin from "./UpcomingCoin";

const PrivateSale = ({ showHeader = true }) => {
  const [currentTab, setCurrentTab] = useState("active");

  return (
    <>
      <div className="newpool-background"> 
        {showHeader && <Header showHeader={showHeader} />}
        </div>
        <div>
          <div className="main-private-sale">
            <div className="left">
              <ul className="trade-ul">
                <li
                  onClick={() => setCurrentTab("active")}
                  className={currentTab === "active" ? "trade-ul-active" : ""}
                >
                  Active
                </li>
                <li
                  onClick={() => setCurrentTab("upcoming")}
                  className={currentTab === "upcoming" ? "trade-ul-active" : ""}
                >
                  Upcoming
                </li>
              </ul>
            </div>
          </div>
          {currentTab === "active" ? (
            <ActiveCoin />
          ) : currentTab === "upcoming" ? (
            <div>
              <UpcomingCoin />
            </div>
          ) : null}
      </div>
    </>
  );
};

export default PrivateSale;
